import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsNotesImportExportTable = _resolveComponent("AnalyticsNotesImportExportTable")!

  return (_openBlock(), _createBlock(_component_AnalyticsNotesImportExportTable, {
    filter: _ctx.filter,
    title: _ctx.getTitle,
    storePaths: _ctx.storePaths,
    tableClass: "analytics-notes-products-table",
    loadStrategy: "infiniteScroll",
    isMonthly: _ctx.isMonthly
  }, null, 8, ["filter", "title", "storePaths", "isMonthly"]))
}